import { hashCode } from '@fullstory/util/string';
import { sortBy } from 'lodash';
import colorClasses from './colors.module.scss';

// Sort the array so the order is deterministic. (Objects in JS are not ordered)
export const arrayOfAccentColors = sortBy(Object.keys(colorClasses), s =>
  Number(s.split('-')[1]),
) as Array<keyof typeof colorClasses>;

/**
 * Deterministically returns a color to be used by the `Avatar` component given a string.
 *
 * @returns AvatarProps['color']
 */
export function getAvatarColorFromString(value: string): keyof typeof colorClasses {
  return arrayOfAccentColors[hashCode(value) % arrayOfAccentColors.length]!;
}
